export default __webpack_public_path__ + "static/media/ntra.b94a94f3.png";